export default __webpack_public_path__ + "img/calendarGray600.81eace2c.svg";